import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatMenuModule } from '@angular/material/menu';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper'
import { ChartsModule } from 'ng2-charts';
import { ModalModule, BsModalService } from 'ngx-bootstrap/modal';
import { NgxPaginationModule } from 'ngx-pagination';

/* swiper */
import {
  SwiperModule,
  SwiperConfigInterface,
  SWIPER_CONFIG
} from 'ngx-swiper-wrapper';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto'
};

const SwiperConfig = {
  provide: SWIPER_CONFIG,
  useValue: DEFAULT_SWIPER_CONFIG
};
/* */

import { SearchBoxComponent } from './search-box/search-box.component';
import { HighlightComponent } from './highlight/highlight.component';
import { ShowcaseBenefitsComponent } from './showcase-benefits/showcase-benefits.component';
import { ShowcaseFeaturesComponent } from './showcase-features/showcase-features.component';
import { ProfileComponent } from './profile/profile.component';
import { StepsComponent } from './steps/steps.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { StagingFilterComponent } from './staging-filter/staging-filter.component';
import { PlanCardComponent } from './plan-card/plan-card.component';
import { SectionIconComponent } from './section-icon/section-icon.component';
import { PrevServiceComponent } from './prev-service/prev-service.component';
import { FaqComponent } from './faq/faq.component';
import { BannerComponent } from './banner/banner.component';
import { NewsletterComponent } from './newsletter/newsletter.component';
import { SanitizeUrlPipe } from './sanitize-url.pipe';
import { SanitizeHtmlPipe } from './sanitize-html.pipe';
import { CapitalizePipe } from './capitalize.pipe';
import { SectionAnchorBannerComponent } from './section-anchor-banner/section-anchor-banner.component';
import { SectionCardInfoComponent } from './section-card-info/section-card-info.component';
import { SectionCardIconeTituloLinkComponent } from './section-card-icone-titulo-link/section-card-icone-titulo-link.component';
import { SectionChartComponent } from './section-chart/section-chart.component';
import { ButtonsComponent } from './buttons/buttons.component';
import { SectionCardSaudeComponent } from './section-card-saude/section-card-saude.component';
import { BottomNavComponent } from './bottom-nav/bottom-nav.component';
import { SectionCountersComponent } from './section-counters/section-counters.component';
import { CounterComponent } from './counter/counter.component';
import { SectionSocialComponent } from './section-social/section-social.component';
import { AccordionComponent } from './modal/accordion/accordion.component';
import { TextComponent } from './modal/text/text.component';
import { ColumnComponent } from './modal/column/column.component';
import { ModalComponent } from './modal/modal.component';
import { ModalService } from './modal/modal.service';
import { TabsComponent } from './modal/tabs/tabs.component';
import { BottomNavModalComponent } from './modal/bottom-nav-modal/bottom-nav-modal.component';
import { SectionFlowChartComponent } from './modal/section-flow-chart/section-flow-chart.component';
import { SectionFlowDataCardsComponent } from './modal/section-flow-data-cards/section-flow-data-cards.component';
import { SectionHighlightComponent } from './modal/section-highlight/section-highlight.component';
import { SectionTimelineComponent } from './modal/section-timeline/section-timeline.component';
import { SectionProfileComponent } from './modal/section-profile/section-profile.component';
import { BannerMenuComponent } from './banner-menu/banner-menu.component';
import { PagesIncComponent } from './pages-inc/pages-inc.component';
import { SectionTaxComponent } from './section-tax/section-tax.component';
import { DownloadPageComponent } from './modal/download-page/download-page.component';
import { OtherInsuranceComponent } from './other-insurance/other-insurance.component';
import { CardComponent } from './card/card.component';
import { SectionCertificationComponent } from './section-certification/section-certification.component';
import { ChatComponent } from './chat/chat.component';
import { StagingGalleryComponent } from './staging-gallery/staging-gallery.component';
import { NewsCarouselComponent } from './news-carousel/news-carousel.component';
import { DynamicTableComponent } from './dynamic-table/dynamic-table.component';
import { ListNewsComponent } from './list-news/list-news.component';
import { ListPublishingComponent } from './list-publishing/list-publishing.component';
import { SearchResultsComponent } from './search-results/search-results.component';
import { CropImagePipe } from './crop-image.pipe';
import { RemoveVersionPipe } from './remove-version.pipe';
import { LoadingComponent } from './loading/loading.component';
import { FloatingMenuComponent } from './floating-menu/floating-menu.component';
import { NewBannerComponent } from './new-banner/new-banner.component';
import { NewBannerMainComponent } from './new-banner/new-banner-main/new-banner-main.component';
import { InvestmentReportComponent } from './investment-report/investment-report.component';
import { IconeTituloComponent } from './icone-titulo/icone-titulo.component';
import { SlugifyPipe } from './slugify.pipe';
import { FilterPipe } from './filter.pipe';
import { DescricaoCorFundoComponent } from './descricao-cor-fundo/descricao-cor-fundo.component';
import { ImagemTituloDescricaoComponent } from './imagem-titulo-descricao/imagem-titulo-descricao.component';
import { SectionImagemComponent } from './section-imagem/section-imagem.component';
import { LinkInternoVoltarComponent } from './link-interno-voltar/link-interno-voltar.component';
import { TituloSubtituloCorFundoComponent } from './titulo-subtitulo-cor-fundo/titulo-subtitulo-cor-fundo.component';
import { UnidadesClinicaComponent } from './unidades-clinica/unidades-clinica.component';
import { BannerTextoGrandeComponent } from './banner-texto-grande/banner-texto-grande.component';

const MODULES = [
  CommonModule,
  FormsModule,
  MatButtonModule,
  MatIconModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatInputModule,
  MatSelectModule,
  MatMenuModule,
  MatStepperModule,
  ChartsModule,
  FormsModule,
  ReactiveFormsModule,
  SwiperModule,
  NgxPaginationModule,
  RouterModule,
  ModalModule.forRoot()
];

const COMPONENTS = [
  SearchBoxComponent,
  HighlightComponent,
  ShowcaseBenefitsComponent,
  ShowcaseFeaturesComponent,
  ProfileComponent,
  StepsComponent,
  ProgressBarComponent,
  StagingFilterComponent,
  PlanCardComponent,
  SectionIconComponent,
  PrevServiceComponent,
  FaqComponent,
  BannerComponent,
  NewsletterComponent,
  SectionAnchorBannerComponent,
  SectionCardInfoComponent,
  SectionCardIconeTituloLinkComponent,
  SectionChartComponent,
  SectionCardSaudeComponent,
  ButtonsComponent,
  BottomNavComponent,
  CounterComponent,
  SectionCountersComponent,
  SectionSocialComponent,
  AccordionComponent,
  TextComponent,
  ColumnComponent,
  TabsComponent,
  BottomNavModalComponent,
  SectionFlowChartComponent,
  SectionFlowDataCardsComponent,
  SectionHighlightComponent,
  SectionTimelineComponent,
  SectionProfileComponent,
  BannerMenuComponent,
  PagesIncComponent,
  SectionTaxComponent,
  DownloadPageComponent,
  ModalComponent,
  OtherInsuranceComponent,
  SectionCertificationComponent,
  CardComponent,
  ChatComponent,
  StagingGalleryComponent,
  NewsCarouselComponent,
  DynamicTableComponent,
  ListNewsComponent,
  ListPublishingComponent,
  SearchResultsComponent,
  LoadingComponent,
  FloatingMenuComponent,
  NewBannerComponent,
  NewBannerMainComponent,
  InvestmentReportComponent,
  IconeTituloComponent,
  DescricaoCorFundoComponent,
  ImagemTituloDescricaoComponent,
  SectionImagemComponent,
  LinkInternoVoltarComponent,
  TituloSubtituloCorFundoComponent,
  UnidadesClinicaComponent,
  BannerTextoGrandeComponent
];

const PIPES = [
  SanitizeUrlPipe,
  SanitizeHtmlPipe,
  CapitalizePipe,
  SlugifyPipe,
  RemoveVersionPipe,
  CropImagePipe,
  FilterPipe
];

const COMPONENTS_AND_PIPES = [...COMPONENTS, ...PIPES];

@NgModule({
  declarations: COMPONENTS_AND_PIPES,
  imports: MODULES,
  entryComponents: COMPONENTS,
  exports: COMPONENTS_AND_PIPES,
  providers: [PIPES]
})
export class LibUiModule {
  static forRoot(): ModuleWithProviders<LibUiModule> {
    return {
      ngModule: LibUiModule,
      providers: [ModalService, BsModalService, SwiperConfig]
    };
  }
}
